(function () {
    "use strict";

    angular.module("app").component("dashboardButton", {
        transclude: {
            'title': 'buttonTitle',
            'description': '?buttonDescription'
        },
        bindings: {
            counter: "=",
            icon: "@",
            href: "@",
            inactive: "="
        },
        template: `
            <a class="btn btn-lg btn-habil-lg dashboard-button" ng-href="{{!$ctrl.inactive ? $ctrl.href : 'javascript:void(0)'}}" ng-disabled="$ctrl.inactive">
                <div>
                    <i class="{{$ctrl.icon}}"></i>
                    <span class="dashboard-button-title" ng-transclude="title"></span>
                    <span class="dashboard-button-description"><small ng-transclude="description"></small></span>
                    <span class="dashboard-button-counter align-center">{{$ctrl.counter}}</span>
                </div>        
            </a>`,
    });

})();